<div class="display-flex mt-3">
    <div class="col-md-6">
        <h5>Packet Log <a class="ml-3 pointer" (click)="download()" ngbPopover="Download"
                triggers="mouseenter:mouseleave" placement="left"><i class="fas fa-download font-size-14"></i></a></h5>
    </div>
    <div class="col-md-6 text-right">
        <button class="btn btn-circle btn-download-success mr-3" ngbPopover="Copy" triggers="mouseenter:mouseleave"
            placement="left"><i class="fa fa-copy" (click)="copyLink()"></i></button>
        <a href="javascript:" mat-dialog-close><i class="fa fa-times-circle text-secondary"></i></a>
    </div>
</div>
<mat-dialog-content class="mat-typography" style="overflow:hidden;">
    <iframe #myIframe *ngIf="fileSource" style="width: 100%" height="400px" [src]="fileSource"
        title="View log content"></iframe>
</mat-dialog-content>